<div class="row">
  <!-- column -->
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Storico Pagamenti</h4>
        <mat-divider  ></mat-divider>
      </div>
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
          <tr>
            <th class="border-top-0">SOFTWARE</th>
            <th class="border-top-0" *ngIf="!layoutManager.smallMode">DATA</th>
            <th class="border-top-0">PREZZO</th>
            <th class="border-top-0">SCARICA</th>
          </tr>
          </thead>
          <tbody>

          <tr *ngFor="let bill of bills.bills;let i = index">
            <td class="txt-oflo">{{bill.software_name.toUpperCase()}}</td>
            <td class="txt-oflo" *ngIf="!layoutManager.smallMode">{{bill.date}}</td>
            <td class="txt-oflo" >{{bill.price.replace("EUR","")}}&euro;</td>
            <td class="txt-oflo">
              <button matTooltip="Scarica Fattura" mat-stroked-button style="margin-left: 0; width: 30px; background: transparent"
              (click)="downloadFile(bill.software_name, bill.date, bill.id, bill.price)"
              [disabled]="downloading">
                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" *ngIf="downloading"></span>
                <mat-icon>get_app</mat-icon>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
